<template>
  <!-- <SliderPart/> -->
   <ContentSection />
    <!-- <IconCardsSection/> -->
    <!-- <SectionTable/> -->
    <HorisontalNewsSection2/>
    <SectionOther/>
    <SectionCall/>
</template>

<script>
import ContentSection from "./SectionHero.vue";
// import IconCardsSection from "./SectionIconCard.vue";
import HorisontalNewsSection2 from "./SectionNewsHorisontal2.vue";
import SectionOther from "./SectionOther.vue";
import SectionCall from "./SectionCall.vue";
// import SectionTable from "./SectionTabel.vue";
// import SliderPart from "./SliderPart.vue";
export default {
  name: "HalamanHome",
  components: {
    // SliderPart,
    ContentSection,
    // IconCardsSection,
    HorisontalNewsSection2,
    SectionOther,
    SectionCall,
    // SectionTable,
  },
};
</script>

<style>
/* Tambahkan style khusus di sini */
</style>
